module.exports = __webpack_public_path__ + "img/Bear21.c498981c.jpg";